<template>
  <VaLayout
    class="bg-white"
    :top="{ fixed: true, order: 2 }"
    :left="{ fixed: true, absolute: breakpoints.mdDown, order: 1, overlay: breakpoints.mdDown && !isSidebarMinimized }"
    @leftOverlayClick="isSidebarMinimized = true"
  >
    <template #top>
      <AppNavbar :is-mobile="isMobile" />
    </template>

    <template #left>
      <AppSidebar :minimized="isSidebarMinimized" :animated="!isMobile" :mobile="isMobile" />
    </template>

    <template #content>
      <div :class="{ minimized: isSidebarMinimized }" class="app-layout__sidebar-wrapper">
        <div v-if="isFullScreenSidebar" class="flex justify-end">
          <VaButton class="px-4 py-4" icon="md_close" preset="plain" @click="onCloseSidebarButtonClick" />
        </div>
      </div>
      <AppLayoutNavigation v-if="!isMobile" class="p-4" />
      <main class="p-4 pt-0 layout-width">
        <!-- <Search /> -->
        <article>
          <RouterView />
        </article>
      </main>
      <Footer class="mt-8 py-4"></Footer>
    </template>
  </VaLayout>
  <AlertSuggestion v-if="alertStore.alertPopUp == 'false'" ref="showAlertModal" />
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { onBeforeRouteUpdate } from 'vue-router'
import { useBreakpoint } from 'vuestic-ui'
import { useAuthStore } from '../stores/authStore.js'
import { useGlobalStore } from '../stores/global-store'
import { useRouter } from 'vue-router'
import AppLayoutNavigation from '../components/app-layout-navigation/AppLayoutNavigation.vue'
import AppNavbar from '../components/navbar/AppNavbar.vue'
import AppSidebar from '../components/sidebar/AppSidebar.vue'
import Footer from '@/components/Footer.vue'
import AlertSuggestion from '../components/AlertSuggestion.vue'
import { useAlertStore } from '../stores/alertStore.js'
import { fetchDataInboxPlacement } from '@/data/api/fetchData'
// import Search  from '../components/Search.vue'

const alertStore = useAlertStore()
const GlobalStore = useGlobalStore()
const auth = useAuthStore()
const breakpoints = useBreakpoint()
const router = useRouter()
const sidebarWidth = ref('16rem')
const sidebarMinimizedWidth = ref(undefined)
const showAlertModal = ref()
const isMobile = ref(false)
const isTablet = ref(false)
const { isSidebarMinimized } = storeToRefs(GlobalStore)

const onResize = () => {
  isSidebarMinimized.value = breakpoints.mdDown
  isMobile.value = breakpoints.smDown
  isTablet.value = breakpoints.mdDown
  sidebarMinimizedWidth.value = isMobile.value ? '0' : '4.5rem'
  sidebarWidth.value = isTablet.value ? '100%' : '16rem'
}

const openAlertModal = () => {
  showAlertModal.value.toggleSuggestionAlertModal()
}

const checkIspMonitorPermission = async () => {
  try {
    const response = await fetchDataInboxPlacement('allowed-users-hash')
    console.log('response : ', response)

    if (response.hash) {
      // Decode base64 string
      const decodedString = atob(response.hash)
      console.log('decodedString : ', decodedString)

      // Parse the JSON object
      const parsedData = JSON.parse(decodedString)
      console.log('parsedData : ', parsedData)

      // Extract allowed_users array
      const allowedEmails = parsedData || []
      console.log('allowedEmails : ', allowedEmails)

      // Check if current user email is in the allowed list
      const isAllowed = allowedEmails.includes(auth.email.toLowerCase())

      // Update state and localStorage
      auth.setIsAllowedIspMonitor(isAllowed)
      localStorage.setItem('isAllowedIspMonitor', isAllowed.toString())

      console.log('ISP Monitor permission check:', isAllowed)
      return isAllowed
    }
  } catch (error) {
    console.error('Error checking ISP monitor permission:', error)
    // Default to false if API call fails
    auth.setIsAllowedIspMonitor(false)
    localStorage.setItem('isAllowedIspMonitor', 'false')
    return false
  }
}

onMounted(() => {
  if (alertStore.alertPopUp == 'false') {
    openAlertModal()
  }
  window.addEventListener('resize', onResize)
  GlobalStore.setSideBar(true)
  if (auth.isLoggedIn === false) {
    // push({ name: 'login' })
    // window.location.href='/auth/login'
    router.push(currentPath.replace('/dashboard', '/auth/login'))
    window.location.href = '/auth/login'
  }
  checkIspMonitorPermission()
  onResize()
  // if (breakpoints.mdDown) {
  // Collapse sidebar after route change for Mobile
  isSidebarMinimized.value = true
  // }
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize)
})

onBeforeRouteUpdate(() => {
  if (breakpoints.mdDown) {
    // Collapse sidebar after route change for Mobile
    isSidebarMinimized.value = true
  }
})

const isFullScreenSidebar = computed(() => isTablet.value && !isSidebarMinimized.value)

const onCloseSidebarButtonClick = () => {
  isSidebarMinimized.value = false
}
</script>

<style lang="scss" scoped>
// Prevent icon jump on animation
.va-sidebar {
  width: unset !important;
  min-width: unset !important;
}
</style>
